var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "toggleMenu" } }, [
    _c(
      "div",
      { ref: "menu", staticClass: "menu", on: { click: _vm.toggleMenu } },
      [_c("img", { attrs: { src: _vm.menuImg } })]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "menu-child" },
      _vm._l(_vm.menuList, function(item) {
        return _c("div", { key: item.name, attrs: { id: item.name } }, [
          _c("img", { attrs: { src: item.src } })
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }